import { numberLocale } from '@/lib/format';

// Prices are computed by the server only (GET /services/{id}/pricing-preview,
// the same engine as bookings). This module only formats amounts.
export function formatTHB(n) {
  // Shown as recorded by the server (whole baht for new bookings; legacy amounts may have satang).
  return `${Number(n || 0).toLocaleString(numberLocale(), { maximumFractionDigits: 2 })} THB`;
}
